import { connect } from 'react-redux';

import { getDocumentById, getOverlayById } from 'src/selectors/layers';
import { DOCUMENT, BACKGROUND, OVERLAY, LayerType } from 'src/pages/editor/components/layer/layerTypes';
import { setColorProfile, PROFILE_COLORS, setEffect, updateEffectProperty } from '../../documents/slice';
import advancedView from './view';
import { RootState } from 'src/store/storeManager.js';
import type { Document as SceneDocType } from 'src/pages/editor/components/documents/slice';
import { DocumentEffect } from 'src/config/effects';
import { getDecorationSpecs } from 'src/selectors/pages/editor';
import { resolvePrintWhiteForHint } from '../resolvePrintWhiteForHint';

function getLayerFromStore(state: RootState, id: string, type: LayerType) {
    switch (type) {
        case OVERLAY:
            return getOverlayById(state, id);
        case DOCUMENT:
        default:
            return getDocumentById(state, id);
    }
}

const mapStateToProps = (state: RootState, ownProps: { id: string; type: LayerType; warpType?: string }) => {
    const { id, type, warpType } = ownProps;
    let colorProfile: string = PROFILE_COLORS[0].value;
    let effect: DocumentEffect | undefined;

    if (id && type && type !== BACKGROUND) {
        const layer = getLayerFromStore(state, id, type);
        if (layer) {
            colorProfile = (layer as SceneDocType).colorProfile || PROFILE_COLORS[0].value;
            effect = (layer as SceneDocType).effect;
        }
    }

    return {
        effect,
        colorProfile,
        profileColors: PROFILE_COLORS,
        printWhite: resolvePrintWhiteForHint(warpType, getDecorationSpecs(state).printWhite),
    };
};

const advancedContainer = connect(mapStateToProps, {
    changeProfileColor: setColorProfile,
    setEffect,
    updateEffectProperty,
})(advancedView);

export default advancedContainer;
